/*------------------------------------*\
    MODULES
\*------------------------------------*/
import 'whatwg-fetch';

/*------------------------------------*\
    TABLE DROPDOWNS
\*------------------------------------*/
class TableDropdowns {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.dropdownTriggers = self.elem.querySelectorAll('[data-table-dropdown-trigger]');
    }

    init() {
        let self = this;

        [...self.dropdownTriggers].map(trigger => {
            let dropdownId = trigger.getAttribute('data-table-dropdown-trigger');
            let dropdown = document.getElementById(`table-dropdown-${dropdownId}`);
            let horseId = dropdown.getAttribute('data-horse-wapiid');

            // When the trigger (horse name) is clicked...
            trigger.addEventListener('click', evt => {
                evt.preventDefault();

                if (dropdown.classList.contains('is-open')) {
                    // Close the dropdown
                    dropdown.classList.remove('is-open');
                    trigger.setAttribute('aria-expanded', false);
                } else {
                    // Open the dropdown
                    dropdown.classList.add('is-open');
                    trigger.setAttribute('aria-expanded', true);

                    if (!dropdown.hasAttribute('data-horse-loaded')) {
                        // Fetch the horse details
                        fetch(`/entries-table-horse-detail/${horseId}`)
                            .then(function (response) {
                                return response.text();
                            }).then(function (body) {
                                dropdown.innerHTML = body;
                                dropdown.setAttribute('data-horse-loaded', true);
                            }).catch(function (ex) {
                                console.log('Parsing failed', ex);
                            });
                    }
                }
            });
        });
    }
}

export default TableDropdowns;
